import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';
import { LegendItem, LegendLabel, LegendOrdinal } from '@visx/legend';
import { scaleOrdinal } from '@visx/scale';

export function StackedAreaChartLegend({
  belegungen,
}: {
  belegungen: BelegungsIntervall[];
}) {
  const scaleData: Record<string, string> = {};
  belegungen.forEach((belegung) => {
    if (!scaleData[belegung.belegung.arbeitsbereich.name]) {
      scaleData[belegung.belegung.arbeitsbereich.name] = belegung.borderColor;
    }
  });

  const ordinalColorScale = scaleOrdinal({
    domain: Object.keys(scaleData),
    range: Object.values(scaleData),
  });

  const legendGlyphSize = 10;

  return (
    <LegendOrdinal scale={ordinalColorScale}>
      {(labels) => (
        <div className="flex gap-4 pb-5">
          {labels.map((label, i) => {
            return (
              <LegendItem className="flex gap-2" key={`legend-quantile-${i}`}>
                <svg width={legendGlyphSize} height={legendGlyphSize}>
                  <circle
                    fill={label.value}
                    r={legendGlyphSize / 2}
                    cx={legendGlyphSize / 2}
                    cy={legendGlyphSize / 2}
                  />
                </svg>
                <LegendLabel className="text-sm">{label.text}</LegendLabel>
              </LegendItem>
            );
          })}
        </div>
      )}
    </LegendOrdinal>
  );
}
